module.exports = __webpack_public_path__ + "resources/img/bg_cover_marketplace_m_v2.e5a28aad1b95fd985ced479fa7ea3b7c.png";